// extracted by mini-css-extract-plugin
export default {"Hover":"stylesCommon_Hover__5E4FD"};